/* global window */
angular
  .module('optionsList')
  .component('optionsList', {
    template: require('./options-list.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'Upload',
      function _($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService, Upload) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'options';

        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.loginMember = AuthService.loginMember();
        this.isTh = this.loginMember && this.loginMember.COUNTRY_CODE === 'TH';
        this.durations = Array(101).fill().map((x, i) => i * 5);

        $resource(`${APIURL}/admin/goods/options/names`).get({}, (data) => {
          this.options = data.options.map((option, index) => {
            option.KEY = index;
            return option;
          });
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });

        $resource(`${APIURL}/admin/meta/subscription/add `).get().$promise
          .then((data) => {
            this.meta = data;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });

        this.addOption = (option) => {
          if (!confirm($translate.instant('추가 하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/goods/options/names/${window.encodeURIComponent(option.OPTION_NAME)}`).save(this.newOption, (data) => {
            alert($translate.instant('추가 되었습니다.'));
            option.data = data;
            this.newOption = {};
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        this.deleteOption = (option, targetOption) => {
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/goods/options/names/${window.encodeURIComponent(targetOption.OPTION_NAME)}`).delete({ GROUP_GOODS_ID: targetOption.GROUP_GOODS_ID },
            () => {
              alert($translate.instant('삭제되었습니다'));
              const options = option.data.options;
              options.splice(options.indexOf(targetOption), 1);
              if (options.length < 1) {
                this.options = this.options.filter(opt => opt !== option);
              }
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.addOptionByGoodsType = (targetOption, goodsType) => {
          if (!confirm($translate.instant('추가 하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/goods/options/names/${window.encodeURIComponent(targetOption.OPTION_NAME)}/types/${window.encodeURIComponent(goodsType)}`).save({}, (data) => {
            alert($translate.instant('추가 되었습니다.'));
            targetOption.data.goodsTypes = data.goodsTypes;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        this.deleteOptionByGoodsType = (targetOption, goodsType) => {
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/goods/options/names/${window.encodeURIComponent(targetOption.OPTION_NAME)}/types/${window.encodeURIComponent(goodsType)}`).delete({}, (data) => {
            alert($translate.instant('삭제되었습니다'));
            targetOption.data.goodsTypes = data.goodsTypes;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        this.modifyPrices = (targetOption) => {
          this.targetModifyPriceOptions = $.extend({}, targetOption); // eslint-disable-line
          this.targetModifyPriceOptionsOriginal = targetOption;
          this.targetModifyPriceOptions.DURATION = this.targetModifyPriceOptions.DURATION.toString();
          jQuery('#modal-modifyPrice').modal('show');
        };
        this.submitModifyPrices = () => {
          if (this.targetModifyPriceOptions.DURATION === undefined) {
            alert($translate.instant('세차 시간을 선택해주세요.'));
            return;
          }
          if (this.targetModifyPriceOptions.DURATION_TXT.length < 1) {
            alert($translate.instant('세차 시간 표기를 입력해주세요.'));
            return;
          }
          if (this.targetModifyPriceOptions.OPTION_PRICE === undefined) {
            alert($translate.instant('세차 가격을 입력해주세요.'));
            return;
          }
          if (isNaN(parseInt(this.targetModifyPriceOptions.OPTION_PRICE, 10)) === true || parseInt(this.targetModifyPriceOptions.OPTION_PRICE, 10) < 0) {
            alert($translate.instant('올바른 세차 가격을 입력해주세요.'));
            return;
          }
          if (this.targetModifyPriceOptions.PRICE === undefined) {
            alert($translate.instant('세차 가격을 입력해주세요.'));
            return;
          }
          if (isNaN(parseInt(this.targetModifyPriceOptions.PRICE, 10)) === true || parseInt(this.targetModifyPriceOptions.PRICE, 10) < 0) {
            alert($translate.instant('올바른 세차 가격을 입력해주세요.'));
            return;
          }
          if (this.targetModifyPriceOptions.EMPLOYEE_PRICE === undefined) {
            alert($translate.instant('정산을 입력해주세요.'));
            return;
          }
          if (isNaN(parseInt(this.targetModifyPriceOptions.EMPLOYEE_PRICE, 10)) === true || parseInt(this.targetModifyPriceOptions.EMPLOYEE_PRICE, 10) < 0) {
            alert($translate.instant('올바른 정산 가격을 입력해주세요.'));
            return;
          }
          $resource(`${APIURL}/admin/goods/options/names/${window.encodeURIComponent(this.targetModifyPriceOptions.OPTION_NAME)}/pricesAndDuration`).save(this.targetModifyPriceOptions, () => {
            alert($translate.instant('수정되었습니다.'));
            this.targetModifyPriceOptionsOriginal.DURATION = this.targetModifyPriceOptions.DURATION;
            this.targetModifyPriceOptionsOriginal.DURATION_TXT = this.targetModifyPriceOptions.DURATION_TXT;
            this.targetModifyPriceOptionsOriginal.PRICE = this.targetModifyPriceOptions.PRICE;
            this.targetModifyPriceOptionsOriginal.OPTION_PRICE = this.targetModifyPriceOptions.OPTION_PRICE;
            this.targetModifyPriceOptionsOriginal.EMPLOYEE_PRICE = this.targetModifyPriceOptions.EMPLOYEE_PRICE;
            jQuery('#modal-modifyPrice').modal('hide');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        this.modifyText = (targetOption, title, subtitle, text, targetText) => {
          this.text = { targetOption, title, subtitle, text, targetText };
          jQuery('#modal-modifyText').modal('show');
        };
        this.submitModifyText = () => {
          $resource(`${APIURL}/admin/goods/options/names/${window.encodeURIComponent(this.text.targetOption.OPTION_NAME)}/${this.text.targetText}`).save({ text: this.text.text }, (data) => {
            alert($translate.instant('수정되었습니다.'));
            this.text.targetOption.data = data;
            this.text.targetOption.OPTION_NAME = data.option.OPTION_NAME;
            this.text.targetOption.OPTION_NAME_EN = data.option.OPTION_NAME_EN;
            jQuery('#modal-modifyText').modal('hide');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        this.modifyImages = (targetOption) => {
          this.targetModifyImageOption = $.extend({}, targetOption); // eslint-disable-line
          jQuery('#modal-modifyImage').modal('show');
        };

        this.modifyImagesRemoveAt = (url) => {
          const URLS = [];
          if (this.targetModifyImageOption.data.option.URLS) {
            this.targetModifyImageOption.data.option.URLS.forEach((item) => {
              if (item !== url) {
                URLS.push(item);
              }
            });
          }
          this.targetModifyImageOption.data.option.URLS = URLS;
        };

        this.modifyImagesNewImage = () => {
          this.targetModifyImageOption.data.option.URLS.push('');
        };

        this.modifyImagesUploadImage = (media, files, index) => {
          console.log('modifyImagesUploadImage');
          if (files && files.length) {
            const file = files[0];
            Upload.upload({
              url: `${APIURL}/admin/file/options`,
              file,
            }).progress(() => {
            }).success((data) => { // eslint-disable-line no-unused-vars
              this.targetModifyImageOption.data.option.URLS[index] = data.url;
            });
          }
        };

        this.submitModifyImages = () => {
          $resource(`${APIURL}/admin/goods/options/names/${window.encodeURIComponent(this.targetModifyImageOption.OPTION_NAME)}/images`).save({ URL: this.targetModifyImageOption.data.option.URLS }, (data) => {
            alert($translate.instant('수정되었습니다.'));
            this.targetModifyImageOption.data = data;
            jQuery('#modal-modifyImage').modal('hide');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };


        this.modifyThumbnailImages = (targetOption) => {
          this.targetModifyThumbnailImageOption = $.extend({}, targetOption.data.option); // eslint-disable-line
          this.targetModifyThumbnailImageOptionOriginal = targetOption;
          jQuery('#modal-modifyThumbnailImage').modal('show');
        };
        this.modifyThumbnailImagesUploadImage = (media, files) => {
          console.log('modifyImagesUploadImage');
          if (files && files.length) {
            const file = files[0];
            Upload.upload({
              url: `${APIURL}/admin/file/options`,
              file,
            }).progress(() => {
            }).success((data) => { // eslint-disable-line no-unused-vars
              this.targetModifyThumbnailImageOption.THUMBNAIL_URL = data.url;
            });
          }
        };

        this.submitModifyThumbnailImages = () => {
          $resource(`${APIURL}/admin/goods/options/names/${window.encodeURIComponent(this.targetModifyThumbnailImageOption.OPTION_NAME)}/thumbnailimage`)
            .save({ URL: this.targetModifyThumbnailImageOption.THUMBNAIL_URL }, (data) => {
              alert($translate.instant('수정되었습니다.'));
              this.targetModifyThumbnailImageOptionOriginal.data = data;
              jQuery('#modal-modifyThumbnailImage').modal('hide');
            }, (err) => {
              console.error(err);
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };


        this.loadDataIfNeeded = (option) => {
          if (option.data) {
            return;
          }

          $resource(`${APIURL}/admin/goods/options/names/:name`).get({ name: option.OPTION_NAME }, (data) => {
            option.data = data;
            console.log(data);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/options-list/options-list.component.js